import { CatalogSettings } from '../root-store/catalog-store/state';

export enum CatalogSettingKey {
}
export class SettingsReader {
  private settingsRaw: { [key: string]: string }

  constructor(settingsRaw: { [key: string]: string }) {
    this.settingsRaw = settingsRaw
  }

  public getSettings(): CatalogSettings {
    return {
      PersistItemsTreeSelection: this.asBoolean('persistItemsTreeSelection', false),
      PreselectedItemIds: this.asNumberArray('preselectedItemIds'),
      ShowConditions: this.asBoolean('showConditions', true),
      DefaultReservationDuration: this.asNumber('defaultReservationDuration', 3),
      Feature_ReservationUsedTimeSlots: this.asBoolean('feature_ReservationUsedTimeSlots', false),
      Feature_HideVAT: this.asBoolean('feature_HideVAT', false),
      Feature_OutlookExport: this.asBoolean('feature_OutlookExport', false),
      Feature_CustomerRoles: this.asBoolean('feature_CustomerRoles', false),
      Feature_NotificationOnOverlappingWithBlockInfo: this.asBoolean('feature_NotificationOnOverlappingWithBlockInfo', false),
      Feature_MailAttachments: this.asBoolean('feature_MailAttachments', false),
      Feature_GlutzDoors: this.asBoolean('feature_GlutzDoors', false),
      Feature_TimeExtension: this.asBoolean('feature_TimeExtension', false),
      Feature_PricesPeriodOfValidity: this.asBoolean('feature_PricesPeriodOfValidity', false),
      HeaderLogoWithoutPaddings: this.asBoolean('headerLogoWithoutPaddings'),
      EnableFreeAccessories: this.asBoolean('enableFreeAccessories', false),
      EnableItemRecommendations: this.asBoolean('enableItemRecommendations', false),
      GiftCards: {
        FeatureEnabled: this.asBoolean('feature_GiftCards', false),
        StandardPrices: this.asNumberArray('giftCardStandardPrices')
      },
      Payment: {
        InvoiceEnabled: this.asBoolean('invoiceEnabled', true),
        OnlinePaymentEnabled: this.asBoolean('onlinePaymentEnabled', false),
        OnlinePaymentMethods: this.asArray('onlinePaymentMethods'),
        PayCashEnabled: this.asBoolean('payCashEnabled', false),
        TransactionAbortedMessage: this.asString('paymentTransactionAbortedMessage'),
      },
      Checkout: {
        GreetingCompany: this.asBoolean('checkoutGreetingCompany', false),
        RequireGreeting: this.asBoolean('checkoutRequireGreeting', true),
        RequireCompany: this.asBoolean('checkoutRequireCompany', false),
        RequireFirstName: this.asBoolean('checkoutRequireFirstName', true),
        RequireLastName: this.asBoolean('checkoutRequireLastName', true),
        RequireStreet: this.asBoolean('checkoutRequireStreet', true),
        RequireZip: this.asBoolean('checkoutRequireZip', true),
        RequireCity: this.asBoolean('checkoutRequireCity', true),
        RequireEmail: this.asBoolean('checkoutRequireEmail', true),
        RequirePhone: this.asBoolean('checkoutRequirePhone', true),
        RequirePurpose: this.asBoolean('checkoutRequirePurpose', true),
        ShowPurpose: this.asBoolean('checkoutShowPurpose', true),
        PurposeMinLength: this.asNumber('checkoutPurposeMinLength', 10),
        EmailPromptForJanitor: this.asBoolean('emailPromptForJanitor', false)
      },
      Calendar: {
        DefaultView: this.asString('defaultCalendarView'),
        YearViewEnabled: this.asBoolean('yearViewEnabled', false),
        SlotDivisions: this.asNumber('calendarSlotDivisions', 1),
        SlotDuration: this.asNumber('calendarSlotDuration', 60),
        WorkDayStart: this.asString('calendarWorkDayStart', '08:00'),
        WorkDayEnd: this.asString('calendarWorkDayEnd', '18:00'),
        ShowWorkHours: this.asBoolean('calendarShowWorkHours', false),
        ShowAvailabilityOnSlots: this.asBoolean('calendarShowAvailabilityOnSlots', false),
      },
      IcalFeed: {
        FeatureEnabled: this.asBoolean('feature_IcalFeeds', false)
      },
      MobileInfoscreens: {
        Visible: this.asBoolean('mobileInfoscreensVisible', false),
        FeatureEnabled: this.asBoolean('feature_MobileInfoscreens', false)
      }
    } as CatalogSettings
  }

  private asString(settingName: string | CatalogSettingKey, defaultValue?: string): string | undefined {
    return this.settingsRaw[settingName] ?? defaultValue
  }

  private asBoolean(settingName: string, defaultValue?: boolean): boolean | undefined {
    const setting = this.settingsRaw[settingName]
    if (!setting)
      return defaultValue

    switch (setting.toLowerCase()) {
      case 'true':
        return true
      case 'false':
        return false
      default:
        return defaultValue
    }
  }

  private asNumber(settingName: string, defaultValue?: number) {
    const setting = this.settingsRaw[settingName]
    if (!setting)
      return defaultValue

    return +setting
  }

  private asArray(settingName: string, defaultValue?: any): string[] {
    const setting = this.settingsRaw[settingName]
    if (!setting)
      return defaultValue

    return setting.split(',')
  }

  private asNumberArray(settingName: string, defaultValue?: any) {
    return this.asArray(settingName, defaultValue)?.map(Number)
  }
}
